export function Syringe() {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.8145 2.9248L13.5438 5.19545L16.4632 8.11485L18.7339 5.8442L15.8145 2.9248Z"
        fill="#D0D3DC"
        stroke="#D0D3DC"
        strokeWidth="1.50133"
        strokeLinejoin="round"
      />
      <path
        d="M20.562 2.158C20.8552 1.86484 20.8552 1.38955 20.562 1.0964C20.2689 0.803245 19.7936 0.803245 19.5005 1.0964L20.562 2.158ZM17.8048 4.91521L20.562 2.158L19.5005 1.0964L16.7432 3.85361L17.8048 4.91521Z"
        fill="#D0D3DC"
      />
      <path
        d="M1.86719 11.0332L10.9498 20.1158"
        stroke="#D0D3DC"
        strokeWidth="1.50133"
        strokeLinecap="round"
      />
      <path
        d="M18.0849 9.73552L9.3267 18.4937L3.4879 12.6549L12.2461 3.89673L18.0849 9.73552Z"
        fill="#D0D3DC"
      />
      <path
        d="M9.3267 18.4937L8.7959 19.0245L9.3267 19.5553L9.8575 19.0245L9.3267 18.4937ZM18.0849 9.73552L18.6157 10.2663C18.9088 9.97317 18.9088 9.49788 18.6157 9.20472L18.0849 9.73552ZM12.2461 3.89673L12.7769 3.36593C12.4837 3.07278 12.0084 3.07278 11.7153 3.36593L12.2461 3.89673ZM3.4879 12.6549L2.9571 12.1241L2.4263 12.6549L2.9571 13.1857L3.4879 12.6549ZM9.8575 19.0245L18.6157 10.2663L17.5541 9.20472L8.7959 17.9629L9.8575 19.0245ZM18.6157 9.20472L12.7769 3.36593L11.7153 4.42753L17.5541 10.2663L18.6157 9.20472ZM11.7153 3.36593L2.9571 12.1241L4.0187 13.1857L12.7769 4.42753L11.7153 3.36593ZM9.8575 17.9629L4.0187 12.1241L2.9571 13.1857L8.7959 19.0245L9.8575 17.9629Z"
        fill="#D0D3DC"
      />
      <path
        d="M9 11.1968L11.9194 14.1162"
        stroke="white"
        strokeWidth="1.50133"
        strokeLinecap="round"
      />
      <path
        d="M12.0168 10.0501L14.0505 11.9845"
        stroke="white"
        strokeWidth="1.50133"
        strokeLinecap="round"
      />
      <path
        d="M4.09388 20.8099C4.38704 21.103 4.86233 21.103 5.15548 20.8099C5.44863 20.5167 5.44863 20.0414 5.15548 19.7483L4.09388 20.8099ZM2.23608 16.8289C1.94293 16.5357 1.46764 16.5357 1.17449 16.8289C0.881333 17.122 0.881333 17.5973 1.17449 17.8905L2.23608 16.8289ZM6.20234 14.7204L2.63418 18.2886L3.69578 19.3502L7.26394 15.782L6.20234 14.7204ZM2.63418 19.3502L4.09388 20.8099L5.15548 19.7483L3.69578 18.2886L2.63418 19.3502ZM3.69578 18.2886L2.23608 16.8289L1.17449 17.8905L2.63418 19.3502L3.69578 18.2886Z"
        fill="#D0D3DC"
      />
    </svg>
  );
}
